import { render } from "./ResolvingLimitationStepOne.vue?vue&type=template&id=5e64ab4d&scoped=true&ts=true"
import script from "./ResolvingLimitationStepOne.vue?vue&type=script&lang=ts"
export * from "./ResolvingLimitationStepOne.vue?vue&type=script&lang=ts"

import "./ResolvingLimitationStepOne.vue?vue&type=style&index=0&id=5e64ab4d&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e64ab4d"]])

export default __exports__